// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"7c96b586","244":"b5bc9564","643":"699b0f33","825":"8ee75637","944":"328e32ee"}[chunkId] + ".css";
};